module.exports = __webpack_public_path__ + "img/phone2.a0b8afa9.png";